"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSwitch = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../utils");
const config_1 = require("../../config");
/** 语言切换组件 */
const LanguageSwitch = ({ language }) => {
    const renderItems = [];
    Object.entries(config_1.languageOptions).forEach(([key, value], index) => {
        if (key === language) {
            renderItems.push(react_1.default.createElement("span", { key: key }, value));
        }
        else {
            renderItems.push(react_1.default.createElement("a", { key: key, className: "site-language", href: (0, utils_1.newUrl)({ query: { language: key } }) }, value));
        }
        if (index < Object.keys(config_1.languageOptions).length - 1) {
            renderItems.push(react_1.default.createElement("span", { key: key + '-separator', className: "site-language-separator" }, "/"));
        }
    });
    return react_1.default.createElement("span", { className: "site-languages" }, renderItems);
};
exports.LanguageSwitch = LanguageSwitch;
